
export default function ServiceArea() {
  return (
    <section id="zone" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6 font-nunito">
            Zone d'intervention
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-nunito">
            Nous intervenons rapidement dans toute la région nantaise
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-800 mb-8 font-nunito">
                Nantes et alentours
              </h3>
              
              <div className="space-y-6">
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-map-pin-line text-xl text-red-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800 font-nunito">Nantes centre</h4>
                    <p className="text-gray-600 font-nunito">Intervention en moins de 20 minutes</p>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-roadster-line text-xl text-red-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800 font-nunito">Périphérie nantaise</h4>
                    <p className="text-gray-600 font-nunito">Rezé, Saint-Herblain, Orvault, Vertou...</p>
                  </div>
                </div>
                
                <div className="flex items-center">
                  <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mr-4">
                    <i className="ri-time-line text-xl text-red-600"></i>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-800 font-nunito">Délai moyen</h4>
                    <p className="text-gray-600 font-nunito">30 minutes selon disponibilité et distance</p>
                  </div>
                </div>
              </div>
              
              <div className="mt-8 p-6 bg-stone-50 rounded-2xl">
                <h4 className="font-bold text-gray-800 mb-2 font-nunito">Zone étendue sur demande</h4>
                <p className="text-gray-600 mb-4 font-nunito">
                  Nous pouvons également intervenir dans un rayon plus large selon l'urgence de votre situation.
                </p>
                <a
                  href="tel:0610143936"
                  className="inline-flex items-center text-red-600 font-semibold hover:text-red-700 transition-colors cursor-pointer font-nunito"
                >
                  <i className="ri-phone-line mr-2"></i>
                  Vérifier notre disponibilité
                </a>
              </div>
            </div>
            
            <div className="relative">
              <div className="aspect-square bg-stone-100 rounded-2xl overflow-hidden shadow-lg">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d86016.57493693717!2d-1.6532322!3d47.2173077!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4805ee811df2b5f5%3A0xb0e01243c25b0a4e!2sNantes!5e0!3m2!1sfr!2sfr!4v1703874562891!5m2!1sfr!2sfr"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen={true}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Zone d'intervention Nantes"
                ></iframe>
              </div>
              
              <div className="absolute -bottom-4 -right-4 bg-white rounded-2xl p-4 shadow-lg">
                <div className="flex items-center">
                  <div className="w-10 h-10 bg-red-600 rounded-full flex items-center justify-center mr-3">
                    <i className="ri-map-pin-fill text-white"></i>
                  </div>
                  <div>
                    <p className="font-semibold text-gray-800 text-sm font-nunito">Zone couverte</p>
                    <p className="text-red-600 text-sm font-nunito">Nantes & région</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
